import {FacebookAdsPage} from 'src/components/facebook/page/Page';
import {GridType} from 'src/enums/GridType';
import {useFAGradeRefresh} from 'src/hooks/facebook/useFAGradeRefresh';

export const GradeRefresh = (): JSX.Element => {
  useFAGradeRefresh();

  return <FacebookAdsPage gridType={GridType.TAB}><></></FacebookAdsPage>;
};
